var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import debounce from 'quasar/src/utils/debounce.js';;
import HtmlTemplateEditor from './HtmlTemplateEditor.vue';
import rpc from 'src/api/rpc';
const renderedTemplateContainer = document.createElement('div');
export default Vue.extend({
    components: { HtmlTemplateEditor },
    data() {
        return {
            content: '',
            rawContent: '',
            renderedTemplate: '',
            visible: false,
            callBackForSaving: undefined,
            title: 'Edit template',
            variables: {},
            partials: {},
            delayEmit: 1000,
            tab: 'edit'
        };
    },
    watch: {
        rawContent() {
            return __awaiter(this, void 0, void 0, function* () {
                const payload = {
                    api_version: 1,
                    action: 'call',
                    entity: 'email.compile_html_template',
                    action_arguments: [
                        { argument_number: 1, value: this.rawContent, type: 'text' },
                        { argument_number: 2, value: JSON.stringify(this.variables), type: 'jsonb' },
                        { argument_number: 3, value: JSON.stringify(this.partials || {}), type: 'jsonb' }
                    ]
                };
                const response = yield rpc('generic_controllers.rpc', payload);
                if (response) {
                    this.renderedTemplate = response.template;
                }
            });
        }
    },
    created() {
        this.handleInput = debounce(this.handleInput, this.delayEmit);
    },
    methods: {
        openDialog(params) {
            const { content, rawContent, variables, partials, callBackForSaving, title } = params;
            this.content = content;
            this.rawContent = rawContent.replace('&gt;', '>');
            this.variables = variables;
            this.partials = partials;
            renderedTemplateContainer.style.display = 'none';
            renderedTemplateContainer.innerHTML = rawContent.slice(0);
            document.body.append(renderedTemplateContainer);
            if (callBackForSaving)
                this.callBackForSaving = callBackForSaving;
            if (title)
                this.title = title;
            this.visible = true;
        },
        handleInput({ value, editableId }) {
            // @ts-ignore
            const editableBlock = renderedTemplateContainer.querySelector(`[data-editable='${editableId}']`);
            // @ts-ignore
            editableBlock.innerHTML = value;
            // have to replace '>' encoded by browser as 'html entity' -> '&gt;', otherwise partials won't render, if any
            this.rawContent = renderedTemplateContainer.innerHTML.replace('&gt;', '>');
        },
        save() {
            if (this.callBackForSaving && this.rawContent)
                this.callBackForSaving(this.rawContent);
            this.visible = false;
        }
    }
});
